import React from "react";
import { getPageTitle } from "../../utils/getPageTitle";
import { useLocation } from "react-router-dom";
import AnalyticsBarChart from "../../components/common/analyticsBarChart";
import IndustryPieChart from "../../components/common/industryPieChart";
import MatrixSummaryCards from "../../components/matrixSummaryCards";
import LineChartComponent from "../../components/common/activeUserLineChart";
import '../../assets/styles/chart.css'



const Analytics = () => {
  const location = useLocation();

  return (
    <>
      <div className="page-body">
        <div className="page-header">
          <h1 className="page-title">{getPageTitle(location.pathname)}</h1>
          <p style={{ color: "rgb(85, 85, 85)", fontSize: "13px" }}>
            Manage your product catalog
          </p>
        </div>
      </div>

      <div className="dashboard-content">
        <LineChartComponent
          
        />

        <AnalyticsBarChart
          
        />
      </div>
      <div className="analytics">
        <IndustryPieChart />
        <div className="key-metrics-panel">
          <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "600" }}>Key Metrics Summary</h3>
          <MatrixSummaryCards />
        </div>
      </div>
    </>
  );
};

export default Analytics;
